import { defineNuxtPlugin } from '#app'

/* Stores */
import { useCityStore } from '@/store/city/city'
import { useAppStore } from '@/store/app/app'

import { NotFoundError, Success } from '@/api/results'

export default defineNuxtPlugin(async ({ $cityPrefix, ssrContext }) => {
  const appStore = useAppStore()

  if (process.server) {
    // проверяем запрос, что это webview
    appStore.detectWebview(ssrContext?.event.node.req.headers)
  }

  const { getCityInfo, cityInfo } = useCityStore()

  if (!cityInfo.domain_prefix) {
    console.time('getCityInfo')
    const result = await getCityInfo($cityPrefix as string)
    console.timeEnd('getCityInfo')

    if (result instanceof Success) return

    if (result instanceof NotFoundError)
      return navigateTo('https://farfor.ru', {
        external: true,
      })

    showError({
      ...result,
      message: `Модель города не была получена: Город: ${$cityPrefix}`,
    })
  }
})
